import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from './EventTypes.module.css'
import { MdOutlinePeopleAlt } from 'react-icons/md'
import { CalendarContext } from '../../CalendarContext'
import CalendarUsersPopUp from './CalendarUsersPopUp'
import { IoClose } from 'react-icons/io5'
import CustomDescriptionInput from './CustomDescriptionInput'
import AdditionalCalendarInfoBlock from './AdditionalCalendarInfoBlock'
import { ReactComponent as IconFacturaGPT } from "../../../../assets/FacturaLogoIconGreen.svg";
import DateHourInfo from './DateHourInfo'

const EventType = ({
	usersToInvite,
	setUsersToInvite,
	location,
	setLocation,
	description,
	setDescription,
	attachment,
	setAttachment,
	addMeet,
	setAddMeet,
	meetId,
	visibility,
	setVisibility,
	availability,
	setAvailability,
	notification,
	setNotification,
	eventColor,
	setEventColor,
	expandedAdditionalInfo,
	setExpandedAdditionalInfo,
	timezone,
	repeat,
	setTimezone,
	setRepeat,
	hourDataExpanded,
	setHourDataExpanded,
	allDay,
	setAllDay,
}) => {
	const searchPeopleRef = useRef(null)
	const [showPeoplePopUp, setShowPeoplePopUp] = useState(false)
	const [searchPeople, setSearchPeople] = useState('')
	const [userColors, setUserColors] = useState({})

	const { selectedHour, selectedDate, getRandomColor } =
		useContext(CalendarContext)

	const handleUserInvite = (user) => {
		setUsersToInvite((prevUsersAdded) => {
			const userExists = prevUsersAdded.some((u) => u.id === user.id)

			if (userExists) {
				setUserColors((prevColors) => {
					const newColors = { ...prevColors }
					delete newColors[user.id]
					return newColors
				})
				return prevUsersAdded.filter((u) => u.id !== user.id)
			} else {
				setUserColors((prevColors) => ({
					...prevColors,
					[user.id]: prevColors[user.id] || getRandomColor(),
				}))
				return [
					...prevUsersAdded,
					{ id: user.id, user: user.user, status: 'pending' },
				]
			}
		})
	}

	return (
    <div className={styles.eventTypeContentContainer}>
      <DateHourInfo
        timezone={timezone}
        repeat={repeat}
        setTimezone={setTimezone}
        setRepeat={setRepeat}
        hourDataExpanded={hourDataExpanded}
        setHourDataExpanded={setHourDataExpanded}
        allDay={allDay}
        setAllDay={setAllDay}
      />
      <div className={styles.formCalendar}>
        <button>Encontrar un hueco</button>
      </div>

      <div
        ref={searchPeopleRef}
        onClick={() => !showPeoplePopUp && setShowPeoplePopUp(true)}
        className={styles.addGuestsContainer}
      >
        <MdOutlinePeopleAlt size={20} className={styles.normalIcon} />
        <div className={styles.addGuestsInputWrapper}>
          <input
            value={searchPeople}
            className={styles.addGuestsInput}
            type="text"
            onChange={(e) => setSearchPeople(e.target.value)}
            spellCheck="false"
            placeholder={"Añade invitados"}
          />
          {showPeoplePopUp && (
            <CalendarUsersPopUp
              fromEventCreation={true}
              setShowPeoplePopUp={setShowPeoplePopUp}
              setSearchPeople={setSearchPeople}
              searchPeople={searchPeople}
              searchPeopleRef={searchPeopleRef}
              addedUsers={usersToInvite}
              handleAddUser={handleUserInvite}
            />
          )}
        </div>
      </div>
      {usersToInvite.length > 0 && (
        <div className={styles.invitedUsersContainer}>
          {usersToInvite.map((user, i) => (
            <div className={styles.invitedUserCard} key={i}>
              <div
                style={{
                  border: `2px solid ${userColors[user.id] || getRandomColor()}`,
                }}
                className={styles.initial}
              >
                {user.user[0]}
              </div>
              <span>{user.user}</span>
              <div className={styles.closeButtonContainer}>
                <IoClose
                  className={styles.closeButton}
                  onClick={() => {
                    setShowPeoplePopUp(false);
                    handleUserInvite(user);
                  }}
                />
                <div className={styles.tooltip}>Eliminar</div>
              </div>
            </div>
          ))}
        </div>
      )}
      <div
        style={{ marginBottom: addMeet && "12px" }}
        className={styles.formMeet}
      >
        <div>
          <IconFacturaGPT
            className={styles.iconFacturaGPT}
            style={{ height: "20px", width: "20px", marginRight: 0 }}
          />
          {/* <svg
						width='55'
						height='55'
						viewBox='0 0 222 133'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						style={{ zIndex: 30, fill: 'var(--text-color)' }} 
					>
						<path
							d='M20.0248 0.222384C16.9731 2.92022 13.6417 6.22923 10.3175 10.2326C5.75094 15.7259 2.41954 21.0529 0 25.5951C17.9286 25.2117 31.77 25.313 38.887 25.6168C40.5436 25.6891 43.3555 25.8627 46.3091 27.4864C50.1455 29.5912 52.0309 32.8857 53.7602 35.9091C55.2788 38.5671 56.1471 40.9612 56.6448 42.6175C46.567 64.4967 36.4892 86.3724 26.4115 108.252H54.6212L70.806 72.9808L94.6308 124.048C95.223 125.299 96.9086 128.446 100.611 130.695C104.229 132.894 107.873 132.908 109.758 132.919C117.358 132.966 128.9 133.071 143.356 132.926C146.585 129.831 150.229 125.878 153.811 120.974C157.383 116.085 160.035 111.43 162 107.427C144.932 107.467 131.821 107.387 124.824 107.366C123.756 107.362 121.565 107.333 119.051 106.302C113.969 104.219 111.506 99.6663 110.336 97.5037C109.493 95.945 108.974 94.5599 108.654 93.5762C88.4003 49.3548 73.1383 17.0423 69.1748 8.94153C68.6189 7.8096 67.2675 5.07198 64.3684 2.96723C60.503 0.160904 56.1071 0.0668788 53.6658 0.0487967C45.4263 -0.0126821 33.9716 -0.0669284 20.0248 0.222384Z'
							fill='currentFill' 
						/>
					</svg> */}
        </div>
        <div className={styles.columnContainer}>
          <button
            onClick={() => setAddMeet((prev) => !prev)}
            className={addMeet ? styles.meetButtonActive : styles.meetButton}
          >
            Añadir videollamada de FacturaGPT Meet
          </button>
          {addMeet && (
            <div
              className={styles.meetLink}
            >{`facturagpt.com/admin/meet/${meetId}`}</div>
          )}
        </div>
      </div>
      <div className={styles.formLocation}>
        <svg fill="none" viewBox="0 0 24 24">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
          />
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171c.1.127.2.251.3.371L12 21l5.13-6.248c.194-.209.374-.429.54-.659l.13-.155Z"
          />
        </svg>
        <div style={{ width: "400px", height: "35px" }}>
          <div className={styles.addGuestsInputWrapper}>
            <input
              value={location}
              className={styles.addGuestsInput}
              type="text"
              onChange={(e) => setLocation(e.target.value)}
              spellCheck="false"
              placeholder={"Añadir ubicación"}
            />
          </div>
        </div>
      </div>
      <CustomDescriptionInput
        attachment={attachment}
        setAttachment={setAttachment}
        description={description}
        setDescription={setDescription}
      />
      <AdditionalCalendarInfoBlock
        notification={notification}
        setNotification={setNotification}
        availability={availability}
        setAvailability={setAvailability}
        visibility={visibility}
        setVisibility={setVisibility}
        eventColor={eventColor}
        setEventColor={setEventColor}
        expandedAdditionalInfo={expandedAdditionalInfo}
        setExpandedAdditionalInfo={setExpandedAdditionalInfo}
      />
    </div>
  );
}

export default EventType
